"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RelatedSPTRendererFactory = void 0;
const DataType_1 = __importDefault(require("@opsbase/lib-datatype/DataType"));
const SPTType_1 = __importDefault(require("@opsbase/lib-spt/SPTType"));
const DataPill_1 = __importDefault(require("@opsbase/web-chips/DataPill"));
const Text_1 = __importDefault(require("@opsbase/web-ui/Text"));
const get_1 = __importDefault(require("lodash/get"));
const react_1 = __importDefault(require("react"));
const RelatedSPTRendererFactory = (viewField, idx, pdf = false) => (item) => {
    const type = (0, get_1.default)(item, viewField.propertyName + 'SPTType');
    const title = {
        [SPTType_1.default.STAFF]: (0, get_1.default)(item, viewField.propertyName + 'Staff.title'),
        [SPTType_1.default.POSITION]: (0, get_1.default)(item, viewField.propertyName + 'Position.title'),
        [SPTType_1.default.TEAM]: (0, get_1.default)(item, viewField.propertyName + 'Team.title'),
    };
    const avatar = {
        [SPTType_1.default.STAFF]: (0, get_1.default)(item, viewField.propertyName + 'Staff.profileImageUrl'),
    };
    const dataType = {
        [SPTType_1.default.STAFF]: DataType_1.default.STAFF,
        [SPTType_1.default.POSITION]: DataType_1.default.POSITION,
        [SPTType_1.default.TEAM]: DataType_1.default.TEAM,
    };
    if (pdf) {
        return react_1.default.createElement(Text_1.default, null, title[type]);
    }
    return title[type] ? (react_1.default.createElement(DataPill_1.default, { value: title[type], type: dataType[type], avatarUrl: avatar[type], textWidth: viewField.width - 60 })) : null;
};
exports.RelatedSPTRendererFactory = RelatedSPTRendererFactory;
exports.default = exports.RelatedSPTRendererFactory;
